import type { Baum } from "@gui-creator/gemeinsam";

const passt = (suche: string, ...texte: (string | null)[]) => texte.some((t) => t?.toLowerCase().includes(suche));

/** Behält Treffer samt Eltern; ein Treffer auf Plugin oder Workspace behält alles darunter. */
export function filtereBaum(baum: Baum, suche: string): Baum {
  const s = suche.trim().toLowerCase();
  if (!s) return baum;
  const plugins = baum.plugins.flatMap((p) => {
    if (passt(s, p.schluessel, p.name)) return [p];
    const workspaces = p.workspaces.flatMap((w) => {
      if (passt(s, w.schluessel, w.name)) return [w];
      const uis = w.uis.filter((u) => passt(s, u.schluessel, u.name));
      return uis.length ? [{ ...w, uis }] : [];
    });
    return workspaces.length ? [{ ...p, workspaces }] : [];
  });
  return { plugins };
}
